import "./styles/AdminImageModal.scss";
import React from "react";
import Modal, {ModalBody, ModalHeader, ModalTitle} from '@atlaskit/modal-dialog';
import {ImageLinkForm} from "./ImageLinkForm";
import Tabs, {Tab, TabList, TabPanel} from '@atlaskit/tabs';
import {ImageUploadForm} from "./ImageUploadForm";
import {MenuItem} from "navigation-common/types/navigation-types";

export interface ImageModalProps {
    onModalClose: () => void,
    menuItem: MenuItem,
    changeTrigger: () => void,
    menuKey: string,
}

export enum ImageType {
    BACKGROUND = "background",
    TEASER = "teaser",
}

const IMAGE_UPLOAD_TAB_KEY = 0;
const IMAGE_URL_TAB_KEY = 1;

function AdminImageModal(props: Readonly<ImageModalProps>) {
    const [imageType] = React.useState<ImageType>(props.menuItem.level === 1 ? ImageType.BACKGROUND : ImageType.TEASER);

    const getDefaultTab = () => {
        if (!props.menuItem.imageUrl) {
            return IMAGE_UPLOAD_TAB_KEY;
        }

        return !props.menuItem.imageStorageName ? IMAGE_URL_TAB_KEY : IMAGE_UPLOAD_TAB_KEY;
    }

    const triggerSetBgImageUrl = (imageUrl: string) => {
        props.menuItem.imageUrl = imageUrl;
        props.menuItem.imageStorageName = "";
        props.changeTrigger();
    }

    const triggerSetBgImageUpload = (imageFileData: ImageFileData) => {
        props.menuItem.imageUrl = imageFileData.downloadUrl;
        props.menuItem.imageStorageName = imageFileData.imageStorageName;
        props.changeTrigger();
    }

    const triggerRemoveBgImageUpload = () => {
        props.menuItem.imageStorageName = "";
        props.menuItem.imageUrl = "";
        props.changeTrigger();
    }

    return (
        <Modal width={"680px"} height={"724px"} autoFocus={false} onClose={props.onModalClose} shouldCloseOnOverlayClick={false}>
            <ModalHeader>
                {imageType === ImageType.BACKGROUND && <ModalTitle>Edit background image</ModalTitle>}
                {imageType === ImageType.TEASER && <ModalTitle>Edit teaser image</ModalTitle>}
            </ModalHeader>
            <ModalBody>
                <p className={"desc"}>
                    {imageType === "background" &&
                        <div>Add a background image to your top level menu item, that will be displayed in its corresponding submenu.</div>}
                    {imageType === "teaser" && <div>Add a teaser image to your 2nd level menu item, that will be displayed on top of the item.</div>}
                </p>
                <div style={{marginTop: "22px"}}>
                    <Tabs id="default" defaultSelected={getDefaultTab()}>
                        <TabList>
                            <Tab key={IMAGE_UPLOAD_TAB_KEY}>Upload image</Tab>
                            <Tab key={IMAGE_URL_TAB_KEY}>Direct link</Tab>
                        </TabList>
                        <TabPanel>
                            <ImageUploadForm onImageChange={triggerSetBgImageUpload} onImageRemove={triggerRemoveBgImageUpload} onCancel={props.onModalClose}
                                             imageType={imageType}
                                             imageUrl={props.menuItem.imageStorageName ? props.menuItem.imageUrl : ""} menuKey={props.menuKey}/>
                        </TabPanel>
                        <TabPanel>
                            <ImageLinkForm onImageChange={triggerSetBgImageUrl} onCancel={props.onModalClose} imageType={imageType}
                                           imageUrl={!props.menuItem.imageStorageName ? props.menuItem.imageUrl : ""}/>
                        </TabPanel>
                    </Tabs>
                </div>
            </ModalBody>
        </Modal>
    );
}

export default AdminImageModal;

export type ImageFileData = {
    downloadUrl: string,
    imageStorageName?: string,
}
